<template>
  <el-drawer
    ref="drawer"
    :title="title"
    size="35%"
    :with-header="true"
    :visible="drawer"
    v-on:update:visible="$emit('update:drawer', $event)"
    v-on:open="onOpenDrawer"
    :before-close="handleClose"
    class="drawer-scroll"
  >
    <el-container class="drawer-body">
      <el-main>
        <el-row>
          <el-col>
            <el-form ref="form" :model="model" label-position="top">
              <el-form-item
                prop="FirstName"
                label="Primer Nombre"
                :rules="[
                  {
                    required: true
                  }
                ]"
              >
                <el-input
                  v-model="model.FirstName"
                  :disabled="disableInput"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="LastName"
                label="Segundo Nombre"
                :rules="[{ required: true }]"
              >
                <el-input
                  v-model="model.LastName"
                  :disabled="disableInput"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="BirthDate"
                label="Fecha de nacimiento"
                :rules="[{ required: true }]"
              >
                <el-date-picker
                  v-model="model.BirthDate"
                  type="date"
                  :picker-options="pickerOptions"
                  default-value="1990-01-01"
                  :disabled="disableInput"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                prop="Email"
                label="Email"
                :rules="[
                  {
                    required: true,
                    message: 'Please input email address',
                    trigger: 'blur'
                  },
                  {
                    type: 'email',
                    message: 'Please input correct email address',
                    trigger: ['blur', 'change']
                  }
                ]"
              >
                <el-input
                  v-model="model.Email"
                  :disabled="disableInput"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="UserName"
                label="Username"
                :rules="[{ required: true }]"
              >
                <el-input
                  placeholder="Nombre de usuario"
                  v-model="model.UserName"
                  :disabled="disableInput"
                ></el-input>
              </el-form-item>
              <el-form-item
                v-if="isNew"
                prop="Password"
                label="Password"
                :rules="[{ required: !isEdit }]"
              >
                <el-input
                  placeholder="Please input password"
                  v-model="model.Password"
                  show-password
                  :disabled="disableInput"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="SalesPersonCode"
                label="Código de Vendedor"
                :rules="[{ required: false }]"
              >
                <el-input
                  placeholder="Código de vendedor"
                  v-model="model.SalesPersonCode"
                  :disabled="disableInput"
                ></el-input>
              </el-form-item>

              <el-form-item
                prop="SupportSellerCode"
                label="Código de Soporte de Ventas"
                :rules="[{ required: false }]"
              >
                <el-input
                  placeholder="Código de Soporte de Ventas"
                  v-model="model.SupportSellerCode"
                  :disabled="disableInput"
                ></el-input>
              </el-form-item>

              <el-form-item
                prop="CustomerServiceExec_"
                label="Código de Servicio al Cliente"
                :rules="[{ required: false }]"
              >
                <el-input
                  placeholder="Código de Servicio al Cliente"
                  v-model="model.CustomerServiceExec_"
                  :disabled="disableInput"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="CustomerServiceExec_"
                label="Código de Gestor de Cobro"
                :rules="[{ required: false }]"
              >
                <el-input
                  placeholder="Código de Gestor de Cobro"
                  v-model="model.paymentAgentExec"
                  :disabled="disableInput"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-main>

      <el-footer>
        <el-row type="flex">
          <el-col :sm="24" :span="4" :xs="24" :lg="4" :md="4">
            <el-button type="danger" @click="closeDrawer" size="small"
              >Cancelar</el-button
            >
          </el-col>
          <el-col :sm="24" :span="4" :xs="24" :lg="4" :md="4">
            <el-button
              v-if="isEdit || isNew"
              :loading="buttonLoading"
              type="primary"
              @click="onSubmit"
              size="small"
              >Guardar</el-button
            >
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </el-drawer>
</template>

<script>
import initialModelData from "@/components/user_manager/userModel";

export default {
  name: "DrawerUserView",
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    disableInput: {
      type: Boolean,
      default: false
    },
    modelData: {
      type: Object,
      default: () => {
        return initialModelData;
      }
    },
    isView: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isNew: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.modelCache = JSON.parse(JSON.stringify(this.model));
  },
  data() {
    return {
      title: "Crear Usuario",
      buttonLoading: false,
      model: initialModelData,
      inputDisabler: false,
      modelCache: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            this.buttonLoading = true;
            this.model.SalesPersonCode =
              this.model.SalesPersonCode &&
              this.model.SalesPersonCode.length > 0
                ? this.model.SalesPersonCode
                : null;

            this.model.SupportSellerCode =
              this.model.SupportSellerCode &&
              this.model.SupportSellerCode.length > 0
                ? this.model.SupportSellerCode
                : null;

            this.model.CustomerServiceExec_ =
              this.model.CustomerServiceExec_ &&
              this.model.CustomerServiceExec_.length > 0
                ? this.model.CustomerServiceExec_
                : null;
            this.$http
              .post("/api/users/update", this.model)
              .then((response) => {
                if (response.data == "Success") {
                  this.$message({
                    type: "success",
                    message: "Usuario Actualizado con éxito"
                  });
                  this.$emit("submit-response", "success");
                } else {
                  this.$message({
                    type: "error",
                    message: "Error al Actualizar Usuario"
                  });
                  this.$emit("submit-response", "error");
                }
              })
              .finally(() => {
                this.buttonLoading = false;
                this.closeDrawer();
              });
          } else {
            // crear usuario
            this.$http
              .post("/api/users", this.model)
              .then(() => {
                this.$emit("submit-response", "success");
                this.$message.success("El usuario fue creado");
              })
              .catch((error) => {
                console.error(error);
                this.$emit("submit-response", "error");
                this.$message.error("Error al crear el usuario");
              });
          }
        } else {
          this.$message({
            type: "error",
            message: "Favor llenar todos los campos solicitados"
          });
          return false;
        }
      });
    },
    handleClose(done) {
      this.$emit("updateDrawerClose");
      this.model = JSON.parse(JSON.stringify(this.modelCache));

      this.$refs.form.resetFields();
      this.$nextTick(function () {
        this.$refs.form.clearValidate();
      });

      done();
    },
    onOpenDrawer() {
      this.model = this.modelData;
    },
    closeDrawer() {
      this.$emit("updateDrawerClose");
      this.model = JSON.parse(JSON.stringify(this.modelCache));

      this.$refs.form.resetFields();
      this.$nextTick(function () {
        this.$refs.form.clearValidate();
      });
    }
  }
};
</script>

<style lang="scss">
.drawer-body {
  height: 100%;
  min-height: 100%;
  max-height: 100%;
}

.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 600px;
}

.drawer-scroll {
  .el-drawer {
    height: 100%;
    overflow: scroll;
  }
}
</style>
